// Shared style constants that reference CSS variables from theme.css
// These are defined once and reused across all components

export const fontStack = "'Inter', sans-serif";

// Glass card
export const glassCard = {
    background: 'var(--card-bg)',
    border: '1px solid var(--card-border)',
    borderRadius: '16px',
    boxShadow: 'var(--card-shadow)',
    padding: '30px 35px',
};

// Pill-shaped input
export const inputStyle = {
    width: '100%',
    padding: '16px 45px 16px 20px',
    border: '1px solid var(--input-border)',
    borderRadius: '30px',
    background: 'var(--input-bg)',
    color: 'var(--text)',
    fontSize: '16px',
    boxSizing: 'border-box',
    fontFamily: fontStack,
    outline: 'none',
    transition: 'all 0.2s ease',
};

// Dashboard compact input
export const dInput = {
    width: '100%',
    padding: '11px 14px',
    border: '1px solid var(--border)',
    borderRadius: '8px',
    fontSize: '14px',
    boxSizing: 'border-box',
    background: 'var(--input-bg)',
    color: 'var(--text)',
    fontFamily: fontStack,
    outline: 'none',
};

// Primary button (main CTA)
export const btnPrimary = {
    width: '100%',
    padding: '14px 24px',
    background: 'var(--btn-primary-bg)',
    color: 'var(--btn-primary-text)',
    border: 'none',
    borderRadius: '30px',
    fontSize: '16px',
    fontWeight: 600,
    cursor: 'pointer',
    fontFamily: fontStack,
    transition: 'all 0.2s ease',
    boxShadow: 'var(--btn-primary-shadow)',
};

// Secondary button
export const btnSecondary = {
    padding: '10px 20px',
    background: 'var(--btn-secondary-bg)',
    color: 'var(--btn-secondary-text)',
    border: '1px solid var(--btn-secondary-border)',
    borderRadius: '30px',
    fontSize: '14px',
    fontWeight: 500,
    cursor: 'pointer',
    fontFamily: fontStack,
    transition: 'all 0.2s ease',
};

// Small button
export const btnSmall = {
    padding: '8px 16px',
    background: 'var(--btn-secondary-bg)',
    color: 'var(--btn-secondary-text)',
    border: '1px solid var(--btn-secondary-border)',
    borderRadius: '20px',
    fontSize: '13px',
    fontWeight: 500,
    cursor: 'pointer',
    fontFamily: fontStack,
    transition: 'all 0.2s ease',
};

// Success button
export const btnSuccess = {
    padding: '10px 20px',
    background: 'var(--success-bg)',
    color: 'var(--success)',
    border: '1px solid var(--success-border)',
    borderRadius: '30px',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    fontFamily: fontStack,
    transition: 'all 0.2s ease',
};

// Danger button
export const btnDanger = {
    padding: '10px 20px',
    background: 'var(--error-bg)',
    color: 'var(--error)',
    border: '1px solid var(--error-border)',
    borderRadius: '30px',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    fontFamily: fontStack,
    transition: 'all 0.2s ease',
};

// Ghost button
export const btnGhost = {
    background: 'transparent',
    border: 'none',
    color: 'var(--text-muted)',
    cursor: 'pointer',
    fontSize: '14px',
    fontFamily: fontStack,
    opacity: 0.8,
};

// Shared layout styles
export const errorBox = {
    padding: '12px 16px',
    background: 'var(--error-bg)',
    border: '1px solid var(--error-border)',
    borderRadius: '30px',
    color: 'var(--error)',
    marginBottom: '20px',
    fontSize: '14px',
};

export const successBox = {
    padding: '12px 16px',
    background: 'var(--success-bg)',
    border: '1px solid var(--success-border)',
    borderRadius: '30px',
    color: 'var(--success)',
    marginBottom: '20px',
    fontSize: '14px',
};
